'use client';

import { cn } from '@coas/ui/lib';
import { useTranslations } from 'next-intl';
import IconChevronRight from '~/shared/assets/icons/chevron-right.svg';
import type { PropsOf } from '~/shared/lib';
import { Price } from '~/shared/ui/price';
import { filterItems } from '../config/filterItems';
import { useProductFilter } from '../model/hooks';

type ProductFilterTriggerProps = Omit<PropsOf<'button'>, 'onClick'>;

export default ({ className, ...props }: ProductFilterTriggerProps) => {
    const [{ filter }, setState] = useProductFilter();
    const t = useTranslations();

    return (
        <>
            <button
                {...props}
                className={cn('md:hidden', className)}
                onClick={() => {
                    setState(prev => ({ ...prev, open: true }));
                }}
            />
            <div className={'hidden md:contents'}>
                {filterItems.map(item => {
                    return (
                        <button
                            key={item.key}
                            type={'button'}
                            onClick={() => setState(prev => ({ ...prev, open: true, selected: item.key }))}
                            className={'flex items-center justify-center gap-x-1 px-6 py-2.5 text-14'}
                        >
                            <div className={cn('mb-0.5 size-3.5 p-1')}>
                                <div
                                    className={cn(
                                        'size-full rounded-full',
                                        item.key !== 'price' && filter[item.key]?.length
                                            ? 'bg-neutral-400'
                                            : 'bg-transparent',
                                    )}
                                />
                            </div>
                            <span className={'space-x-3'}>
                                <span className={'text-neutral-950'}>{t(`productFilter.${item.title}`)}</span>
                                {item.key === 'price' && (
                                    <span className={'font-300 text-neutral-500'}>
                                        <Price withoutCurrency>{filter[item.key][0]}</Price>
                                        {' — '}
                                        <Price withoutCurrency>{filter[item.key][1]}</Price>
                                    </span>
                                )}
                            </span>
                            <IconChevronRight className={'mb-0.5 size-3.5 stroke-neutral-400'} />
                        </button>
                    );
                })}
            </div>
        </>
    );
};
